import { render, staticRenderFns } from "./ipModal.vue?vue&type=template&id=fb745d2a&"
import script from "./ipModal.vue?vue&type=script&lang=js&"
export * from "./ipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports